import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'fin-form-input-radio',
  styleUrls: ['./form-input-radio.component.scss'],
  templateUrl: 'form-input-radio.component.html',
})
export class FormInputRadioComponent implements OnInit {
  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  controlName: string;

  @Input()
  translationPrefix: string;

  @Input()
  radioKey: string;

  @Input()
  isSensitive = false;

  @Input()
  description = false;

  @Input()
  descriptionTitle: string;

  @Input()
  descriptionText: string;

  @Input()
  displayContainerStyles = true;

  control: AbstractControl;

  ngOnInit(): void {
    this.control = this.parentForm.get(this.controlName);
  }
}
